import { render, staticRenderFns } from "./GeneradorCampos.vue?vue&type=template&id=b2f69c52&scoped=true"
import script from "./GeneradorCampos.vue?vue&type=script&lang=js"
export * from "./GeneradorCampos.vue?vue&type=script&lang=js"
import style0 from "./GeneradorCampos.vue?vue&type=style&index=0&id=b2f69c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f69c52",
  null
  
)

export default component.exports